import { Loader } from '@googlemaps/js-api-loader';
import LoggingService from './LoggingService';

export interface Point {
    latitude: number;
    longitude: number;
}

export default class MapService {
    private static loader: Loader | undefined;

    private static instance: MapService | null = null;

    public static SetMapsLoader(apiKey: string): void {
        MapService.loader = new Loader({
            apiKey: apiKey,
            version: 'weekly'
        });
    }

    public static LoadMap(callback: () => void): void {
        if (MapService.loader == null) {
            throw Error('Loader has not been initialized');
        }

        MapService.loader.loadCallback(e => {
            if (e) {
                LoggingService.LogError('Failed to load google maps', e);
            } else {
                callback();
            }
        });
    }

    public static GetDistanceFromLatLon(point1: Point, point2: Point) {
        // Distance between two points using Haversine Formula
        const R = 6371; // Radius of the earth in km
        const dLat = MapService.deg2rad(point2.latitude - point1.latitude);  // deg2rad below
        const dLon = MapService.deg2rad(point2.longitude - point1.longitude);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(MapService.deg2rad(point1.latitude)) * Math.cos(MapService.deg2rad(point2.latitude)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // Distance in km
        return d * 0.621371; // convert to miles
    }

    static deg2rad(deg: number) {
        return deg * (Math.PI / 180)
    }
}